import * as Yup from "yup";
import { getInitialValues } from "layouts/views/common/common";

const formField = {
  warehouseCode: {
    name: "warehouseCode",
    label: "Warehouse Code",
    type: "select",
    errorMsg: "Warehouse Code is required.",
    required: true,
    xs: 6,
    edit: true,
  },
  zoneID: {
    name: "zoneID",
    label: "Zone ID",
    type: "select",
    errorMsg: "Zone ID is required.",
    required: true,
    xs: 6,
    edit: true,
  },
  rack: {
    name: "rack",
    label: "Rack",
    type: "select",
    errorMsg: "Rack Number is required.",
    required: true,
    xs: 6,
    edit: true,
  },
  locationID: {
    name: "locationID",
    label: "Location ID",
    type: "multi-select",
    errorMsg: "Location IDs are required.",
    xs: 12,
    required: true,
  },
  levelSetting:{
    name: "levelSetting",
    label: "Level",
    type: "select",
    errorMsg: "Level setting is required",
    xs: 6,
    required: true,
  },
  selection:{
    name: "selection",
    label: "Selection",
    type: "select",
    errorMsg: "Selection is required",
    xs: 12,
    multiple: true,
  }
};

export const initialValues = getInitialValues(formField);

const { warehouseCode, zoneID, rack, locationID, 
  levelSetting, selection } = formField;

export const formRender = [
  [warehouseCode, zoneID], 
  [rack, levelSetting],
  [locationID],
  [selection], 
];

export const pickFaceLocationValidations = Yup.object().shape({
  [warehouseCode.name]: Yup.string().nullable().max(20).required(warehouseCode.errorMsg),
  [zoneID.name]: Yup.string().nullable().max(20).required(zoneID.errorMsg),
  [rack.name]: Yup.string().nullable().max(20).required(rack.errorMsg),
  [levelSetting.name]: Yup.string().nullable().max(50).required(levelSetting.errorMsg),
});
